import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { main } from '@popperjs/core';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploaderService } from '../service/file-uploader.service';



@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.css']
})
export class RegisterUserComponent implements OnInit {

  form: FormGroup;
  message: string;
  authToken = localStorage.getItem('auth');
  passwordErr = "";
  messageErr = "";
  businessID = this.authService.getTokenData().businessID;
  userID: string = this.route.snapshot.params.id;
  btnText;
  user = [];
  isLoading = false;
  isMainUser = this.authService.getTokenData().mainUser;
  currentUserID = this.authService.getTokenData().userID;
  deleteLoader = false;
  attachmentObj;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  has_expired = false;
  realbtn="";
  not_activated = false;
  subGroups = [];
  saved_subgroups = [];
  show_notification_success = false;
  notification_preferences = [
    {name: 'Uutiskirje', value: 'newsletter', checked: true},
    {name: 'Tykänneet organisaatiosta', value: 'liked_organisation', checked: true},
  ];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private sanitizer: DomSanitizer,
    private fileUploaderService: FileUploaderService,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }


  ngOnInit(): void {
    console.log(this.currentUserID)
    if(!this.userID){
      this.fetchSubGroups();
    }
    
    this.form = this.fb.group({
      email: ['', [
        Validators.email, 
        Validators.required
      ]],

      firstName: ['', Validators.required],
      lastName: ['', Validators.required],

    });

    if(this.userID == this.currentUserID){
      this.btnText = "Muokkaa käyttäjää"
      this.realbtn = "Tallenna";
      this.fetchUserData();
    }
    else if(this.userID){
      this.btnText = "Käyttäjän tiedot"
      this.realbtn = "Tallenna";
      this.fetchUserData();
    }
    else{
      this.btnText = "Lisää käyttäjä"
      this.realbtn = "Lisää käyttäjä";
    }
  }

  get email() { return this.form.get('email') };
  get firstName() { return this.form.get('firstName') };
  get lastName() { return this.form.get('lastName') };

  gotFile(event: any): void {
    this.imageChangedEvent = event;
}

imageCropped(event: ImageCroppedEvent) {
  this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
  console.log(this.croppedImage);
  // event.blob can be used to upload the cropped image
}

fetchSubGroups() {
  this.http.get(environment.SUBGROUPS, this.httpOptions).subscribe(
    (res: any) => {
      if(res.status == 200 ) {
        this.subGroups = res.message;
        console.log(this.subGroups);

        if(this.userID){
          setTimeout(() => {
          var subgroups_ids = this.user['subgroups'] ? this.user['subgroups'] : [];
          for (let i = 0; i < this.subGroups.length; i++) {
            const elem = this.subGroups[i];
            for (let j = 0; j < subgroups_ids.length; j++) {
              const saved = subgroups_ids[j];
              if(elem._id == saved){
                this.saved_subgroups.push(elem);
                (<HTMLInputElement>document.getElementById('subgroups_'+elem._id)).checked = true;
              }
            }
          }
          },100)

        }

      }
      else {
        this.subGroups = [];
      }
      
    }, (err: any) => {

      console.log("Error while finding status :: ", err);
    })
}

saveCroppedImage() {
  console.log('saveCroppedImage');

  var real_url = this.croppedImage.changingThisBreaksApplicationSecurity;

  // Step 1: Convert blob URL to Blob
  fetch(real_url)
    .then(response => response.blob())
    .then(blob => {
      console.log('Blob:', blob);
      // Step 2: Create a File object
      const filename = 'cropped_image.png'; // You can set the filename as per your requirement
      const file = new File([blob], filename, { type: 'image/png' });

      // Now 'file' can be used to upload or save the cropped image
      this.attachmentObj = file;
      this.addImage();
    })
    .catch(error => {
      console.error('Error converting blob URL to File:', error);
    });
}

addImage() {
  this.fileUploaderService.uploadImageServer(this.attachmentObj,(err,result) => {
  
    if(result == false){
      alert('Error while uploading image');
    }
    else{
      console.log(result)
      var logo = result;
      this.user['profilePicture'] = logo;
      var req = {
        profilePicture: logo,
      }

      this.http.post(environment.EMPLOYER_ADD_PROFILE_PICTURE, req, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            document.getElementById('close-confirm-modal2').click();

          }
          else {
            document.getElementById('close-confirm-modal2').click();
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })

    }
 })
}

imageLoaded(image: LoadedImage) {
    // show cropper
    document.getElementById('crop-image').click();
}
cropperReady() {
    // cropper ready
}
loadImageFailed() {
    // show message
}


  fetchUserData(){

    this.http.get(environment.EMPLOYER +'/'+ this.userID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.user = res.message;
          var m = res.message;
          console.log(m)

          this.fetchSubGroups();

          var today_epoch = new Date().getTime();
          if(m.activationTokenExpiracy){
            if(m.activationTokenExpiracy < today_epoch){
              this.has_expired = true;
              console.log('expired')
            }
            else if(m.activationTokenExpiracy > today_epoch){
              this.not_activated = true;
            }

          }

          this.form = this.fb.group({
            firstName: [m.firstName, Validators.required],
            lastName: [m.lastName, Validators.required],
            email: [m.email, Validators.required],
          });
        }
        else {
          console.log('No user')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  onSubmit(){
    if(this.userID){
      this.editUser();
    }
    else{
      this.addNewUser()
    }
  }

  editUser(){
    var t = false;

    console.log('Submitting');
    if (!this.form.valid) {
      console.log('Form not valid. Please check that fields are correctly filled in');
      return;
    }

    this.isLoading = true;

    var subgroups_ids = [];

    if(this.saved_subgroups.length > 0){
      for (let i = 0; i < this.saved_subgroups.length; i++) {
        const sub = this.saved_subgroups[i];

        subgroups_ids.push(sub._id);
        
      }
    }



    var req = {
      email: this.form.get('email').value.toLowerCase(),
      userName: this.form.get('email').value.toLowerCase(),
      firstName: this.form.get('firstName').value,
      lastName: this.form.get('lastName').value,
      subgroups: subgroups_ids,
    }


      this.http.put(environment.EMPLOYER +'/'+ this.userID, req, this.httpOptions).subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.status == 200) {

            var old_subgroups = this.user['subgroups'] ? this.user['subgroups'] : [];
            var new_subgroups = subgroups_ids;

            //check if subgroups have changed
            var t = false;
            if(old_subgroups.length != new_subgroups.length){
              t = true;
            }
            else{
              for (let i = 0; i < old_subgroups.length; i++) {
                const old = old_subgroups[i];
                const new_sub = new_subgroups[i];

                if(old != new_sub){
                  t = true;
                }
              }
            }

            if(t){
              alert('Käyttäjän toimipisteet muutettu. Käyttäjän on kirjauduttava uudelleen, jotta muutokset tulevat voimaan');
              this.authService.doLogOut();
            }

            this.router.navigate(['/'+this.businessID+'/company-details']);
          } else {
            
            alert('Virhe muokatessa käyttäjää. Tarkista, että sinulla on valtuudet tehdä operaatio.')
          }
        }, (err: any) => {

          console.log("Error while login :: ", err);
        }
      )

  }

  addNewUser() {

    var t = false;

    console.log('Submitting');
    if (!this.form.valid) {
      console.log('Form not valid. Please check that fields are correctly filled in');
      return;
    }

    this.isLoading = true;

    var subgroups_ids = [];

    if(this.saved_subgroups.length > 0){
      for (let i = 0; i < this.saved_subgroups.length; i++) {
        const sub = this.saved_subgroups[i];

        subgroups_ids.push(sub._id);
        
      }
    }

    var req = {
      email: this.form.get('email').value,
      userName: this.form.get('email').value,
      firstName: this.form.get('firstName').value,
      lastName: this.form.get('lastName').value,
      subgroups: subgroups_ids,
    }

      this.http.post(environment.USER_REGISTER_END_POINT, req, this.httpOptions).subscribe(
        (res: any) => {
          console.log("Register success");
          this.isLoading = false;
          if (res.status == 200) {

            
            
            this.router.navigate(['/'+this.businessID+'/company-details']);
          } else {
            alert('Virhe lisätessä käyttäjää. Ole hyvä ja yritä uudelleen. Tarkistathan ettei käyttäjää ole jo olemassa')
          }
        }, (err: any) => {

          console.log("Error while login :: ", err);
        }
      )

    }

    removeUser(){
     
      if(this.currentUserID == this.userID){
        alert('Et voi poistaa itseäsi')
        return;
      }
      
      
        this.deleteLoader = true;
        this.http.delete(environment.EMPLOYER +'/'+ this.userID, this.httpOptions).subscribe(
          (res: any) => {
            this.deleteLoader = false;
            if (res.status == 200) {
              document.getElementById('close-confirm-modal').click();
  
              this.router.navigate(['/'+this.businessID+'/company-details']);
            } else {
              
              alert('Virhe poistaessa käyttäjää. Ole hyvä ja yritä uudelleen');
            }
          }, (err: any) => {
  
            console.log("Error while login :: ", err);
          }
        )


    }

    goBack(){
      window.history.back();
  }

  renewActivationCode(){
    this.isLoading = true;
    var req = {
      userID: this.userID,
    }

    this.http.post(environment.EMPLOYER_RENEW_ACTIVATION, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log('Activation renewed');
          this.has_expired = false;
          this.isLoading = false;
        }
        else {
          alert('Error while renewing activation');
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  removeProfilePicture(){
    var deletable = this.user['profilePicture'];

    var req = {
      profilePicture: deletable,
    }
    this.http.post(environment.EMPLOYER_REMOVE_PROFILE_PICTURE, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message);

            this.user['profilePicture'] = '';


        }
        else {
          var anElm = document.getElementById('error');
          anElm.style.display="block";
          document.getElementById('loader').style.display="none";
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })

  }

  saveFavourites(){
    var selected_favourites = [];

    for (let i = 0; i < this.subGroups.length; i++) {
      const elem = this.subGroups[i];

      var check_elem = document.getElementById('subgroups_'+elem._id) as HTMLInputElement;

      if(check_elem.checked){
        selected_favourites.push(elem);
      }
    }

    this.saved_subgroups = selected_favourites;

  }

  saveNotificationPreferences(){


    var new_notifications = [];
    for (let i = 0; i < this.notification_preferences.length; i++) {
      var notification = this.notification_preferences[i];

      var notification_elem = document.getElementById('notification_'+notification.value) as HTMLInputElement;

      if(notification_elem.checked){
        //set checked to true
        notification.checked = true;
      }
      else{
        notification.checked = false;
      }

      new_notifications.push(notification);
      
    }

    var req = {
      preferences: new_notifications,
    }

    this.http.post(environment.EMPLOYER_NOTIFICATION_PREFERENCES, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log('Notification preferences saved');
          this.show_notification_success = true;
        }
        else {
          
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })


  }


}
